"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_i18next_1 = require("react-i18next");
const functions_1 = require("@/common/functions");
const ClickAwayListener_1 = __importDefault(require("@mui/material/ClickAwayListener"));
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const ToggleButton_1 = __importDefault(require("@mui/material/ToggleButton"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1(props) {
    const defaultValue = (0, react_redux_1.useSelector)((state) => state.roomData.refund_policy);
    const [open, setOpen] = (0, react_1.useState)(false);
    const handleClose = () => setOpen(false);
    const dispatch = (0, react_redux_1.useDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const { comment } = props;
    const { name, descriptions, message } = props.propsData;
    const addComment = () => {
        const hasDefaultValue = Boolean(defaultValue);
        dispatch((0, roomCreateStore_1.setRefundPolicy)(`${hasDefaultValue ? defaultValue + '\n' : ''}${comment}`));
        (0, functions_1.showToastMessage)({ message: message });
        handleClose();
        setTimeout(() => {
            const textarea = document.getElementById('refund_editor');
            const end = textarea.value.length;
            textarea.setSelectionRange(end, end);
            textarea.focus();
        }, 0);
    };
    return ((0, jsx_runtime_1.jsx)(ClickAwayListener_1.default, Object.assign({ onClickAway: handleClose }, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ open: open, placement: "bottom-start", title: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [descriptions.map((desc, idx) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: { fontSize: '15px', lineHeight: '26px', color: 'black' } }, { children: desc }), `description_${desc.substring(0, 5)}_${idx}`))), (0, jsx_runtime_1.jsxs)(AddButton, Object.assign({ onClick: addComment }, { children: ["+ ", t('추가하기')] }))] }), arrow: true, disableFocusListener: true, disableHoverListener: true, disableTouchListener: true, 
                // ! sx not working properly
                // ? https://github.com/mui/material-ui/issues/28679#issuecomment-949277606
                componentsProps: {
                    tooltip: {
                        sx: {
                            width: '238px',
                            p: '6px 10px 10px',
                            border: '1px solid rgba(0, 0, 0, 0.2)',
                            borderRadius: '8px',
                            mt: '8px !important',
                            bgcolor: '#fff',
                            boxShadow: '0px 5px 10px 0px #0000000D',
                            '.MuiTooltip-arrow': {
                                color: '#fff',
                                '&::before': {
                                    border: '1px solid rgba(0, 0, 0, 0.2)',
                                    bgcolor: '#fff',
                                },
                            },
                        },
                    },
                } }, { children: (0, jsx_runtime_1.jsx)(ToggleButton_1.default, Object.assign({ value: "open", selected: open, onClick: () => setOpen(!open), sx: {
                        height: '32px',
                        p: '0 12px',
                        border: '1px solid rgba(0, 0, 0, 0.1)',
                        borderRadius: '6px',
                        fontSize: '15px',
                        fontWeight: 'bold',
                        bgcolor: 'var(--white) !important',
                        color: 'var(--gray-80)',
                    } }, { children: (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "subtitle4" }, { children: ["+ ", name] })) })) })) }) })));
}
exports.default = default_1;
const AddButton = (0, styled_1.default)(Button_1.default) `
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 6px 10px;
  margin-top: 10px;
  gap: 10px;
  width: 216px;
  height: 28px;
  background: #ffffff !important;
  border: 1px solid rgba(0, 0, 0, 0.8);
  border-radius: 6px;
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
  color: #000000;
`;
